module.exports = __webpack_public_path__ + "img/image_body-product_01.4b9ebd12.jpg";